import { render, staticRenderFns } from "./FormEventListHistory.vue?vue&type=template&id=6d2d60b5&scoped=true&"
import script from "./FormEventListHistory.vue?vue&type=script&lang=js&"
export * from "./FormEventListHistory.vue?vue&type=script&lang=js&"
import style0 from "./FormEventListHistory.vue?vue&type=style&index=0&id=6d2d60b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d60b5",
  null
  
)

export default component.exports